import { CMSFooter } from '@travelwin/cms/types';

import { FooterItem } from '../components/Footer/components/types';
import { Link } from '../components/Link';
import { useCMSContent } from '../context/CMS';
import { useExternalHomepageConfig } from './useExternalHomepageConfig';

const containsDomain = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const useCmsFooterItems = (
  className?: string,
): {
  navItem?: FooterItem[];
  brandLogo?: CMSFooter['logo'];
  socialPlatforms?: CMSFooter['socialPlatforms'];
  copyrightText?: CMSFooter['copyrightText'];
} => {
  const { getHomepageUrl } = useExternalHomepageConfig();

  const { content } = useCMSContent() || {};
  if (!content) return {};

  const { footer } = content;
  if (!footer) return {};

  const { footerItems, logo, socialPlatforms, copyrightText } = footer;

  const cmsFooterItems = footerItems?.map((item) => {
    const navItem: FooterItem = {
      isDropdown: true,
      title: item.text,
      list:
        item.subFooterItems?.map((subItem) => {
          const isExternalLink = containsDomain(subItem.link);

          if (isExternalLink)
            return (
              <a
                className={`${className}__link`}
                href={getHomepageUrl(new URL(subItem.link).pathname)}
                key={subItem.id}
                rel="noopener noreferrer"
              >
                {subItem.text}
              </a>
            );

          return (
            <Link
              className={`${className}__link`}
              to={subItem.link}
              key={subItem.id}
            >
              {subItem.text}
            </Link>
          );
        }) || [],
    };
    return navItem;
  });

  return {
    navItem: cmsFooterItems,
    brandLogo: logo,
    socialPlatforms,
    copyrightText,
  };
};
